import React, { useState } from 'react';

export const PageHeader = ({ title, subtitle, action }) => (
  <div className="admin-page-header">
    <div>
      <h1 className="page-title">{title}</h1>
      {subtitle ? <p className="page-subtitle">{subtitle}</p> : null}
    </div>
    {action ? <div className="admin-page-actions">{action}</div> : null}
  </div>
);

export const LoadingState = ({ label }) => (
  <div className="admin-loading-state">
    <i className="fa fa-spinner fa-spin"></i>
    <span>{label}</span>
  </div>
);

export const EmptyState = ({ icon = 'fa fa-inbox', title, text }) => (
  <div className="admin-empty-state">
    <i className={icon}></i>
    <strong>{title}</strong>
    {text ? <span>{text}</span> : null}
  </div>
);

export const MetricCard = ({ label, value, icon, accent, detail }) => (
  <div className="analytics-metric">
    <div className="analytics-metric-top">
      <span className="analytics-metric-label">{label}</span>
      <span className="analytics-metric-icon" style={{ color: accent }}>
        <i className={icon}></i>
      </span>
    </div>
    <div className="analytics-metric-value">{value}</div>
    {detail ? <div className="analytics-metric-foot">{detail}</div> : null}
  </div>
);

const RowsPerPageSelect = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);
  const options = [10, 20, 30];

  return (
    <div className="admin-select2" onBlur={() => setOpen(false)} tabIndex={-1}>
      <button type="button" className="admin-select2-control" onClick={() => setOpen(!open)}>
        <span>{value}</span>
        <i className={`fa fa-chevron-${open ? 'up' : 'down'}`}></i>
      </button>
      {open ? (
        <div className="admin-select2-menu">
          {options.map((option) => (
            <button
              key={option}
              type="button"
              className={option === value ? 'active' : ''}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => {
                onChange(option);
                setOpen(false);
              }}
            >
              {option}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
};

export const TableToolbar = ({
  search,
  onSearchChange,
  rowsPerPage,
  onRowsPerPageChange,
  placeholder = 'Search...'
}) => (
  <div className="admin-table-toolbar">
    <label className="admin-table-page-size">
      <span>Rows per page</span>
      <RowsPerPageSelect value={rowsPerPage} onChange={onRowsPerPageChange} />
    </label>
    <label className="admin-table-search">
      <i className="fa fa-search"></i>
      <input
        type="search"
        value={search}
        onChange={(event) => onSearchChange(event.target.value)}
        placeholder={placeholder}
      />
    </label>
  </div>
);
